<template>
    <div >
        <div class="print_xinxi" style="display: flex; flex-wrap: wrap;margin-bottom:20px;line-height:22px;">
            <div style=" width: 24%;margin-right:1%">
                <span >患者编号：</span>
                <span>{{patientInfo.patientId}}</span>
            </div>
            <div style=" width: 24%;margin-right:1%">
                <span >姓名：</span>
                <span>{{patientInfo.patientName}}</span>
            </div>
            <div style=" width: 24%;margin-right:1%">
                <span >性别：</span>
                <span>{{patientInfo.patientSex}}</span>
            </div>
            <div style=" width: 24%;margin-right:1%">
                <span >年龄：</span>
                <span>{{patientInfo.patientAge}}</span>
            </div>
        </div>
        <div class="print_xinxi" style="display: flex; flex-wrap: wrap;margin-bottom:20px;line-height:22px">
            <div style=" width: 24%;margin-right:1%">
                <span >西医疾病：</span>
                <span>{{patientInfo.wcmDisease}}</span>
            </div>
            <div style=" width: 24%;margin-right:1%">
                <span >中医疾病：</span>
                <span>{{patientInfo.tcmDisease}}</span>
            </div>
            <div style=" width: 24%;margin-right:1%">
                <span >中医证候：</span>
                <span>{{patientInfo.tcmDisease}}</span>
            </div>
        </div>
        <div style=" position: relative;font-size: 14px; color: #666;  display: flex; flex: 1; border: 1px solid black; overflow: hidden; margin: 20px 0 ;min-height:500px">
            <div style=" width:30%; border-right: 1px solid black;padding: 4px">
                <div style="min-height:120px">
                    <p style="font-weight: 600;">临床表现：</p>
                    <div style="margin:0 10px;overflow:auto">{{patientInfo.clinicalFeature}}</div>
                </div>
                <div style="min-height:80px">
                    <p style="font-weight: 600;">舌质：</p>
                    <div style="margin:0 10px;overflow:auto">{{patientInfo.tongueNature}}</div>
                </div>
                <div style="min-height:80px">
                    <p style="font-weight: 600;">舌苔：</p>
                    <div style="margin:0 10px;overflow:auto">{{patientInfo.tongueCoating}}</div>
                </div>
                <div style="min-height:80px">
                    <p style="font-weight: 600;">脉象：</p>
                    <div style="margin:0 10px;overflow:auto">{{patientInfo.pulseCondition}}</div>
                </div>
                <div style="min-height:120px">
                    <p style="font-weight: 600;">医学检查：</p>
                    <div style="margin:0 10px;overflow:auto">{{patientInfo.medicalExamination}}</div>
                </div>
            </div>
            <div style=" width: 70%;padding: 4px">
                <div style="min-height:150px">
                    <p style="font-weight: 600;">处方：</p>
                    <div style="margin:0 10px;overflow:auto">{{patientInfo.formulaComposition}}</div>
                </div>
                <div style="min-height:150px">
                    <p style="font-weight: 600;">用法：</p>
                    <div style="margin:0 10px;overflow:auto">{{patientInfo.usageUse}}</div>
                </div>
                <div style="min-height:40px; position: absolute;right: 100px;bottom:0">
                    <p style="font-weight: 600;">医师姓名：{{patientInfo.doctorName}}</p>
                    <p style="height:30px;line-height:30px">{{getTimer}}</p>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    props: ['patientInfo'],
    data () {
        return {
            getTimer:'',
        }
    },
     mounted () {
        this.getDate()  
    },
    methods: {
        getDate() {
            const nowDate = new Date();
            const date = {
                year: nowDate.getFullYear(),

                month: nowDate.getMonth() + 1,

                date: nowDate.getDate(),

                hours: nowDate.getHours(),

                minutes: nowDate.getMinutes(),

                seconds: nowDate.getSeconds(),
            };
            const newmonth = date.month > 10 ? date.month : "0" + date.month;
            const newday = date.date > 10 ? date.date : "0" + date.date;
            const newminutes = date.minutes > 10 ? date.minutes : "0" + date.minutes;
            const newseconds = date.seconds > 10 ? date.seconds : "0" + date.seconds;
            this.getTimer =  date.year +  "-" + newmonth +  "-" + newday +  " " + date.hours + ":" + newminutes +  ":" +  newseconds;

        },
    }
}
</script>

<style>

</style>